/**
 * LLM (Large Language Model) Types
 * ============================================
 * Shared types for LLM integration across the PilatesTime platform.
 * Supports multiple providers (OpenAI, Anthropic, AWS Bedrock, etc.)
 */
// ============================================
// ENUMS
// ============================================
/**
 * Supported LLM providers
 */
export var LLMProvider;
(function (LLMProvider) {
    LLMProvider["OPENAI"] = "openai";
    LLMProvider["ANTHROPIC"] = "anthropic";
    LLMProvider["BEDROCK"] = "bedrock";
})(LLMProvider || (LLMProvider = {}));
/**
 * Message roles for chat completions
 */
export var LLMMessageRole;
(function (LLMMessageRole) {
    LLMMessageRole["SYSTEM"] = "system";
    LLMMessageRole["USER"] = "user";
    LLMMessageRole["ASSISTANT"] = "assistant";
})(LLMMessageRole || (LLMMessageRole = {}));
export var LLMModule;
(function (LLMModule) {
    LLMModule["MEDICAL_RECORD"] = "medical-record";
})(LLMModule || (LLMModule = {}));
// ============================================
// LLM TASK TYPES
// ============================================
/**
 * Types of LLM tasks supported by the platform
 */
export var LLMTaskType;
(function (LLMTaskType) {
    LLMTaskType["ANAMNESIS_SUMMARY"] = "ANAMNESIS_SUMMARY";
    LLMTaskType["SESSION_PLAN_SUGGESTION"] = "SESSION_PLAN_SUGGESTION";
    LLMTaskType["CUSTOMER_WORKOUT_RECOMMENDATION"] = "CUSTOMER_WORKOUT_RECOMMENDATION";
    // Future task types:
    // PERIODIC_EVALUATION_SUMMARY = "PERIODIC_EVALUATION_SUMMARY",
})(LLMTaskType || (LLMTaskType = {}));
/**
 * Configuration map for all LLM task types
 * Centralized source of truth for task-specific LLM settings
 */
export const LLM_TASK_TYPE_CONFIG = {
    [LLMTaskType.ANAMNESIS_SUMMARY]: {
        maxTokens: 5000,
        temperature: 0.3,
    },
    [LLMTaskType.SESSION_PLAN_SUGGESTION]: {
        maxTokens: 3000,
        temperature: 0.5,
    },
    [LLMTaskType.CUSTOMER_WORKOUT_RECOMMENDATION]: {
        maxTokens: 4000,
        temperature: 0.5,
    },
};
/**
 * Status of an LLM task
 */
export var LLMTaskStatus;
(function (LLMTaskStatus) {
    LLMTaskStatus["PROCESSING"] = "PROCESSING";
    LLMTaskStatus["COMPLETED"] = "COMPLETED";
    LLMTaskStatus["FAILED"] = "FAILED";
})(LLMTaskStatus || (LLMTaskStatus = {}));
/**
 * Entity types that can be associated with LLM tasks
 */
export var LLMEntityType;
(function (LLMEntityType) {
    LLMEntityType["MEDICAL_RECORD"] = "MedicalRecord";
    LLMEntityType["CUSTOMER"] = "Customer";
})(LLMEntityType || (LLMEntityType = {}));
//# sourceMappingURL=LLM.js.map